export default __webpack_public_path__ + "static/eth-lisbon-c15b710d474d945193876df78a8d72df.png";